import { render, staticRenderFns } from "./TrainConfigTagsCell.vue?vue&type=template&id=1ab0f622&scoped=true"
import script from "./TrainConfigTagsCell.vue?vue&type=script&lang=js"
export * from "./TrainConfigTagsCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab0f622",
  null
  
)

export default component.exports